import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';
import { syncNativeStatusBar } from '@/services/appearance.service';

let hideScheduled = false;
let hidden = false;
let safetyTimer: ReturnType<typeof setTimeout> | null = null;

/**
 * Скрыть нативный splash один раз. Держим его до auth/route settle,
 * чтобы не мигал чёрный экран между splash и Login/Showcase.
 */
export async function hideNativeSplash(): Promise<void> {
  if (hidden || !Capacitor.isNativePlatform()) {
    hidden = true;
    return;
  }
  hidden = true;
  if (safetyTimer) {
    clearTimeout(safetyTimer);
    safetyTimer = null;
  }
  try {
    await SplashScreen.hide({ fadeOutDuration: 200 });
  } catch {
    /* ignore */
  }
  // После immersive splash insets часто остаются 0 — переприменяем overlay.
  void syncNativeStatusBar();
}

/** Страховка: не держать splash дольше maxMs даже если settle не вызвали. */
export function ensureNativeSplashSafety(maxMs = 4000): void {
  if (hideScheduled || hidden || !Capacitor.isNativePlatform()) return;
  hideScheduled = true;
  safetyTimer = setTimeout(() => {
    void hideNativeSplash();
  }, maxMs);
}
